import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './unidad_medida_utils';

export const useUnidadMedidaStore = defineStore('unidadMedidaStore', {
  state: () => ({
    entity: 'unidad-medida',
    unidadesMedida: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllUnidadMedidaHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.unidadesMedida.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.unidadesMedida = [];
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
  },
});
